module.exports = __webpack_public_path__ + "icon-384x384.png";